<template>
  <header class="site-header">
    <div class="site-header__top">
      <div class="container site-header__top-inner">
        <span>R. Duque de Caxias, 95, Centro, Uberlândia - MG</span>
        <div class="site-header__utility">
          <a
            href="http://carteira.bancariosuberlandia.org.br"
            target="_blank"
            rel="noopener"
            class="site-header__carteira"
          >
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <rect x="3" y="5" width="18" height="14" rx="2" />
              <circle cx="9" cy="11" r="2" />
              <path d="M6.5 16c.6-1.2 1.6-1.8 2.5-1.8s1.9.6 2.5 1.8M14 10h4M14 13.5h3" />
            </svg>
            Minha carteirinha
          </a>
          <a
            href="https://wa.me/553432367277"
            target="_blank"
            rel="noopener"
            class="site-header__whats"
            aria-label="Falar pelo WhatsApp: (34) 3236 7277"
          >
            <img src="@/assets/logo-whatsapp.png" alt="" width="18" height="18" class="site-header__whats-icon" />
            (34) 3236 7277
          </a>
        </div>
      </div>
    </div>

    <div class="site-header__bar">
      <div class="container site-header__main">
        <router-link to="/" class="site-header__logo" aria-label="SEEB Uberlândia, página inicial">
          <img src="@/assets/logo_dark.svg" alt="SEEB Uberlândia" width="150" height="52" />
        </router-link>

        <nav class="site-header__nav" aria-label="Principal">
          <router-link
            v-for="item in items"
            :key="item.name"
            :to="{ name: item.name }"
            :exact="item.name === 'Home'"
            class="site-header__link"
            active-class="is-active"
          >
            {{ item.label }}
          </router-link>
        </nav>

        <div class="site-header__actions">
          <button
            type="button"
            class="site-header__menu"
            :aria-expanded="menuOpen ? 'true' : 'false'"
            aria-controls="menu-mobile"
            @click="$emit('toggle-menu')"
          >
            <span class="site-header__menu-icon" aria-hidden="true"><i></i><i></i></span>
            <span class="site-header__menu-label">Menu</span>
          </button>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import navItems from "./navItems";

export default {
  name: "AppBar",
  props: {
    menuOpen: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    items: navItems,
  }),
};
</script>

<style lang="scss">
// A faixa de endereço rola junto com a página; só a barra principal fica fixa.
.web .site-header {
  position: sticky;
  top: -40px;
  z-index: 5;
  font-family: var(--font-text);

  &__top {
    background: var(--c-navy);
    color: var(--c-on-dark);
    font-size: var(--fs-meta);
  }

  &__top-inner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 24px;
    height: 40px;
    white-space: nowrap;

    a {
      color: #fff;
      font-weight: 600;
      text-decoration: none;
    }

    a:hover {
      text-decoration: underline;
      text-underline-offset: 3px;
    }
  }

  &__bar {
    background: var(--c-surface);
    border-bottom: 1px solid var(--c-line);
  }

  &__main {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 32px;
    height: 84px;
  }

  &__logo {
    display: block;
    flex-shrink: 0;

    img {
      display: block;
      width: auto;
      height: 64px;
    }
  }

  &__nav {
    display: none;
    align-items: stretch;
    align-self: stretch;
    gap: 4px;
  }

  // Item de menu: o traço inferior marca a página atual.
  .site-header__link {
    position: relative;
    display: inline-flex;
    align-items: center;
    padding: 0 12px;
    color: var(--c-ink);
    font-size: 15px;
    font-weight: 500;
    text-decoration: none;
    transition: color 160ms var(--ease);

    &::after {
      content: "";
      position: absolute;
      left: 12px;
      right: 12px;
      bottom: -1px;
      height: 3px;
      background: var(--c-navy-deep);
      transform: scaleX(0);
      transform-origin: left;
      transition: transform 200ms var(--ease);
    }

    &:hover {
      color: var(--c-navy-deep);
    }

    &.is-active {
      color: var(--c-navy-deep);
      font-weight: 600;
    }

    &.is-active::after,
    &:hover::after {
      transform: scaleX(1);
    }
  }

  &__actions {
    display: flex;
    align-items: center;
    align-self: stretch;
    gap: 12px;
  }

  &__utility {
    display: flex;
    align-items: center;
    gap: 24px;
    line-height: 1;

    // Carteira do associado: ícone e contorno sutil para destacar do restante da faixa.
    .site-header__carteira {
      padding: 6px 12px;
      border: 1px solid rgba(255, 255, 255, 0.45);
      border-radius: var(--radius-sm);
      font-weight: 700;
      transition: background-color 160ms var(--ease), border-color 160ms var(--ease);
    }

    .site-header__carteira:hover {
      background: rgba(255, 255, 255, 0.12);
      border-color: #fff;
    }

    .site-header__carteira svg {
      width: 18px;
      height: 18px;
      fill: none;
      stroke: currentColor;
      stroke-width: 1.8;
      stroke-linecap: round;
      stroke-linejoin: round;
    }

    a {
      display: inline-flex;
      align-items: center;
      gap: 8px;
    }

    img {
      display: block;
      width: 18px;
      height: 18px;
    }
  }

  // Logo oficial do WhatsApp, em branco para aparecer sobre a faixa navy.
  &__whats-icon {
    filter: brightness(0) invert(1);
  }

  .site-header__whats {
    gap: 8px;
    white-space: nowrap;

    img {
      display: block;
      width: 18px;
      height: 18px;
    }
  }

  &__menu {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    height: 44px;
    padding: 0 6px 0 10px;
    background: none;
    border: 0;
    border-radius: var(--radius-sm);
    color: var(--c-navy);
    font-family: var(--font-text);
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
  }

  &__menu-icon {
    display: inline-flex;
    flex-direction: column;
    gap: 6px;
    width: 22px;

    i {
      display: block;
      height: 2px;
      background: currentColor;
      border-radius: 2px;
    }
  }

  @media (min-width: 1140px) {
    &__nav {
      display: inline-flex;
    }

    &__menu {
      display: none;
    }
  }

  @media (max-width: 1139px) {
    // Abaixo de 1140 px o endereço sai da faixa, para caber carteira, WhatsApp e telefone numa linha.
    &__top-inner > span {
      display: none;
    }

    &__main {
      height: 72px;
    }

    &__logo img {
      height: 56px;
    }
  }

  @media (max-width: 599px) {
    top: 0;

    &__top {
      display: none;
    }

    &__main {
      height: 64px;
      gap: 16px;
    }

    &__logo img {
      height: 48px;
    }

    &__menu {
      margin-right: -6px;
    }
  }
}
</style>
